import React from 'react';
import { BEFORE_AFTER } from '../../data/mock';
import { X, Check } from 'lucide-react';

const WhyTransaSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111]">
            Battery installs changed the game.
          </h2>
          <div className="mt-6 space-y-4 text-[#475569] text-lg leading-relaxed">
            <p>
              Modern battery installations create a mountain of packaging — inverter boxes, BMS units, 
              multiple battery module boxes. Each install generates significant volumes of foam, plastic, 
              and cardboard that someone has to deal with.
            </p>
            <p>
              As an installer, you're expected to remove it all. But your van has limited space. 
              Most installers operate from home with no commercial bins. The result? Cramped vehicles, 
              weekend tip runs, and lost productive time.
            </p>
          </div>
        </div>

        {/* Before/After Comparison */}
        <div className="mt-10 grid md:grid-cols-2 gap-8">
          {/* Before */}
          <div className="comparison-card comparison-before p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-[#FEE2E2] flex items-center justify-center">
                <X className="w-5 h-5 text-[#EF4444]" />
              </div>
              <h3 className="text-xl font-bold text-[#111111]">Before Transa</h3>
            </div>
            <ul className="space-y-4">
              {BEFORE_AFTER.before.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#FEE2E2] flex items-center justify-center mt-0.5">
                    <X className="w-3 h-3 text-[#EF4444]" />
                  </span>
                  <span className="text-[#111111]">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* After */}
          <div className="comparison-card comparison-after p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-[#DCFCE7] flex items-center justify-center">
                <Check className="w-5 h-5 text-[#22C55E]" />
              </div>
              <h3 className="text-xl font-bold text-[#111111]">After Transa</h3>
            </div>
            <ul className="space-y-4">
              {BEFORE_AFTER.after.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#DCFCE7] flex items-center justify-center mt-0.5">
                    <Check className="w-3 h-3 text-[#22C55E]" />
                  </span>
                  <span className="text-[#111111]">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyTransaSection;
